angular.module('app').directive('apMobileNav', ['$rootScope','$transitions', 'AppRoutes', 'NotificationRepository', 'LocalStorageRepository', 'SessionService', 'GuidList', 'PatientSettingsService', 'NotificationService', 'TransitionManager', 'LogOffService',
    function ($rootScope, $transitions, AppRoutes, NotificationRepository, LocalStorageRepository, SessionService, GuidList, PatientSettingsService, NotificationService, TransitionManager, LogOffService) {
        'use strict';

        return {
            restrict: 'E',
            templateUrl: '/app/partials/mobileNav/views/apMobileNav.html',
            scope: true,
            transclude: false,
            link: function (scope) {
                scope.notifications = {
                    Welcome: { BadgeCount: 0, IsActive: true},
                    Chart: { BadgeCount: 0, IsActive: true},
                    Messages: { BadgeCount: 0, IsActive: true},
                    Forms: { BadgeCount: 0, IsActive: true},
                    Prescriptions: { BadgeCount: 0, IsActive: true},
                    Appointments: { BadgeCount: 0, IsActive: true},
                    Billing: { BadgeCount: 0, IsActive: true},
                    Doctors: { BadgeCount: 0, IsActive: true}
                };

                scope.showMobileNav = SessionService.getShowMobileNav();
                
                scope.headerData = {
                };

                scope.transitionAndCloseNav = function(transition) {
                  TransitionManager.transition(transition);
                  SessionService.setShowMobileNav(false);
                };

                scope.signOff = function() {
                    LogOffService.logoff().then(function() {
                        TransitionManager.transition({appRoute: 'login'});
                        SessionService.setPatientAuthenticated(false);
                        SessionService.setShowMobileNav(false);
                    });
                };
                
                scope.setActivePatient = function(patientId) {
                    $rootScope.$broadcast('ResponsibleParty:updated', patientId);  
                    SessionService.setShowMobileNav(false);
                };

                function getNotifications() {
                    NotificationRepository
                        .getNotifications(LocalStorageRepository.getUserID())
                        .then(function (notifications) {
                            var featureList = PatientSettingsService.getPatientFeatures();

                            scope.notifications.Chart.BadgeCount = _.find(notifications, {NotificationType: 'Chart'}).Count;

                            scope.notifications.Messages.BadgeCount = _.find(notifications, {NotificationType: 'Messages'}).Count;
                            scope.notifications.Messages.IsActive = featureList.SendReceiveMessages.IsActive;

                            scope.notifications.Forms.BadgeCount = _.find(notifications, {NotificationType: 'Forms'}).Count;
                            scope.notifications.Forms.IsActive = featureList.ViewEducationMaterial.IsActive;

                            scope.notifications.Prescriptions.BadgeCount = _.find(notifications, {NotificationType: 'Prescriptions'}).Count;
                            scope.notifications.Prescriptions.IsActive = featureList.RequestRxRefills.IsActive;

                            scope.notifications.Appointments.BadgeCount = _.find(notifications, {NotificationType: 'Appointments'}).Count;
                            scope.notifications.Appointments.IsActive = featureList.ViewAppointments.IsActive;

                            scope.notifications.Billing.BadgeCount = _.find(notifications, {NotificationType: 'Billing'}).Count;
                            scope.notifications.Billing.IsActive = (featureList.ViewPatientStatement.IsActive ||  featureList.ViewPatientLedger.IsActive || featureList.MakeAPayment.IsActive);

                            scope.notifications.Doctors.BadgeCount = _.find(notifications, {NotificationType: 'Doctors'}).Count;
                        });
                }
                getNotifications();

                var responsiblePartyDataListener = $rootScope.$on('HeaderData:updated', function(event, data) {
                    if(!(data && (data.requestor || 'apMobileNav') !== 'apMobileNav'))
                        scope.headerData = data;
                });

                function loadMobileNav() {
                    $rootScope.$broadcast('HeaderData:requested', 'apMobileNav');
                    NotificationService.startNotificationTimer();
                }
                loadMobileNav();

                //var notificationListener = scope.$on('Notification:updated', function (event, data)  {
                var notificationListener = scope.$on('Notification:updated', function ()  {
                    getNotifications();
                });

                var stateChangeListener = $transitions.onSuccess({}, function onTransitionSuccess(transition) {
                    var toState = transition.targetState() || {};
                    var toStateName = toState && toState.name() || '';
                    var appRoute = AppRoutes.findByStateName(toStateName);
                    scope.toolbarItem = (appRoute && appRoute.portalSettings && appRoute.portalSettings.toolbarItem);
                });

                var showMobileNavListener = scope.$on('ShowMobileNav:updated', function(event, data) {
                  scope.showMobileNav = data;
                });

                scope.$on('$destroy', function () {
                    notificationListener();
                    stateChangeListener();
                    showMobileNavListener();
                    responsiblePartyDataListener();
                    NotificationService.stopNotificationTimer();
                });
            }
        };
}]);
